import React, { useEffect, useState, useCallback } from "react";
import Accept from "./Accept";
import Decline from "./Decline";
import axios from "axios";
import { getBaseUrl } from "../../utils/common_lib";
// import { toast } from "react-toastify";

function TOSModal({ userData, setUserData, setShowTosModal, agreementType }) {
  const [state, setState] = useState({
    showAcceptPopUp: true,
    showDeclinePopUp: false,
    termsAndConditions: [],
    loadingTos: false,
  });

  const authToken =
    localStorage.getItem("authToken") ||
    JSON.parse(localStorage.getItem("session"))?.token ||
    userData?.token;
  const practiceId = JSON.parse(localStorage.getItem("session"))?.practice_id;
  const pid = JSON.parse(localStorage.getItem("session"))?.pid;

  useEffect(() => {
    if (!authToken) {
      // toast.error("Your session has expired. Please login again.");
    }
  }, [authToken]);

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      setState((prevState) => ({ ...prevState, loadingTos: true }));
      try {
        const response = await axios.get(
          `${getBaseUrl()}/users/terms_and_conditions.json?type=patient&token=${authToken}&practice_id=${practiceId}&pid=${pid}&encounter=&tz=-240&portal=patient`
        );
        setState((prevState) => ({
          ...prevState,
          termsAndConditions: response?.data?.response?.data,
        }));
      } catch (error) {
        console.error("error", error);
        // toast.error("Error fetching terms and conditions");
      } finally {
        setState((prevState) => ({ ...prevState, loadingTos: false }));
      }
    };

    fetchTermsAndConditions();
  }, [authToken, practiceId, pid]);

  const setShowAcceptPopUp = useCallback((value) => {
    setState((prevState) => ({ ...prevState, showAcceptPopUp: value }));
  }, []);

  const setShowDeclinePopUp = useCallback((value) => {
    setState((prevState) => ({ ...prevState, showDeclinePopUp: value }));
  }, []);

  const { showAcceptPopUp, showDeclinePopUp, termsAndConditions, loadingTos } =
    state;

  const props = {
    showAcceptPopUp,
    setShowAcceptPopUp,
    showDeclinePopUp,
    setShowDeclinePopUp,
    termsAndConditions,
    authToken,
    loadingTos,
    userData,
    setUserData,
    setShowTosModal,
    agreementType,
  };

  return (
    <div>
      {showAcceptPopUp && <Accept {...props} />}
      {showDeclinePopUp && agreementType !== "agreed" && <Decline {...props} />}
    </div>
  );
}

export default React.memo(TOSModal);
